import createCollectionResource from 'src/actions/shared/createResource';
import { updateSkillsWithHierarchies } from 'src/actions/skills/skillsResource';

export interface SkillAncestry {
  id: string;
  skillId: string;
  ancestralSkillId: string;
}

const skillHierarchyResource = createCollectionResource<SkillAncestry>({
  name: 'skillHierarchy',
  endpoint: 'v1/orgs/:orgId/skill-hierarchy/:id',
  observerCreator: ({ actions }) => {
    return ({ dispatch, getState }) => {
      return {
        onBroadcast(item) {
          dispatch(actions.broadcast(item));
          updateSkillsWithHierarchies(dispatch, getState);
        },
        onBroadcastDelete(_: any, { skillHierarchyId }) {
          dispatch(actions.broadcastDelete(skillHierarchyId));
          updateSkillsWithHierarchies(dispatch, getState);
        },
      };
    };
  },
});

export default skillHierarchyResource;
